module.exports = __webpack_public_path__ + "img/03-3.4f0ef468.png";